import React from 'react';
import { Box, TableRow, TableCell, Typography } from '@mui/material';

const NoDataFoundText = ({ text }) => {
  return (
    <Box py={2}>
      <Typography variant="subtitle2" textAlign="center">
        {text}
      </Typography>
    </Box>
  );
};

// colSpan prop is used for displaying in table
function NoDataFound({ colSpan, text = 'No Data Found' }) {
  return colSpan ? (
    <TableRow>
      <TableCell colSpan={colSpan} sx={{ borderBottom: 'none' }}>
        <NoDataFoundText text={text} />
      </TableCell>
    </TableRow>
  ) : (
    <NoDataFoundText text={text} />
  );
}

export default NoDataFound;
